import { CstIndiIncomeEntityIdDto } from './cst-indi_income_entity_id-dto';
import { AddressDTO } from './address-dto';

export class DocListDTO {

  panCardFiles: File[];
  panCardFilesData: any[];
  panCardDocId: any;
  panCardRemovedDocId: any;
  passportSizePhotoFiles: File[];
  passportSizePhotoFilesData: any[];
  passportSizePhotoDocId: any;
  passportSizePhotoRemovedDocId: any;
  idProofFiles: File[];
  idProofFilesData: any[];
  idProofDocId: any;
  idProofRemovedDocId: any;
  addressProofFiles: File[];
  addressProofFilesData: any[];
  addressProofDocId: any;
  addressProofRemovedDocId: any;
  secondAddressProofFiles: File[];
  secondAddressProofFilesData: any[];
  secondAddressProofDocId: any;
  secondAddressProofRemovedDocId: any;
  incomeProofFiles: File[];
  incomeProofFilesData: any[];
  incomeProofDocId: any;
  incomeProofRemovedDocId: any;
  bankStatementFiles: File[];
  bankStatementFilesData: any[];
  bankStatementDocId: any;
  bankStatementRemovedDocId: any;


  constructor() {
    this.panCardFiles=[];
    this.panCardFilesData=[];
    this.passportSizePhotoFiles=[];
    this.passportSizePhotoFilesData=[];
    this.idProofFiles=[];
    this.idProofFilesData=[];
    this.addressProofFiles=[];
    this.addressProofFilesData=[];
    this.secondAddressProofFiles=[];
    this.secondAddressProofFilesData=[];
    this.incomeProofFiles=[];
    this.incomeProofFilesData=[];
    this.bankStatementFiles=[];
    this.bankStatementFilesData=[];
  }
  
}